import React from "react";
import PropTypes from "prop-types";

export function ScreenManager({ style, children }) {
  return <div style={{ ...style, position: "relative" }}>{children}</div>;
}

ScreenManager.propTypes = {
  style: PropTypes.object,
  children: PropTypes.node,
};
ScreenManager.defaultProps = {
  style: {},
  children: null,
};

export default ScreenManager;
